import type React from 'react';

function KustomIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1383.37 1383.37"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Kustom Icon</title>

      <g id="Group_1573" data-name="Group 1573">
        <g id="Group_1033" data-name="Group 1033">
          <path
            id="Path_1041"
            data-name="Path 1041"
            d="M1053.75,694.83l275.45-306.36L988.35,131.35l-298.86,358.77V174.23H252.85V483.77H11v382.57H252.85v330.15h436.64v-312.72c110.82,88.93,172.91,192.11,196.43,312.72h475.2c-36.9-193.63-137.65-360.3-307.26-501.52l-.12-.13Z"
          />
        </g>
        <rect width="1383.37" height="1383.37" fill="none" />
      </g>
    </svg>
  );
}

export default KustomIcon;
